/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { EntityAttributeTemplateComponent } from '../entity-attribute-components/entity-attribute-template/entity-attribute-template.component';
//import { TranslateService } from '@ngx-translate/core';

//import { Constants } from '../../gby.constants';
//import { CommonService } from '../../services/common.service';



@Component({
    selector: 'entity-attributes',
    templateUrl: './entity-attributes.component.html',
    styleUrls: ['./entity-attributes.component.scss'],
    standalone: false
})
export class EntityAttributesComponent implements OnInit {
  @Input() pageId: string;
  @Input() savedObject: any;
  //private language = Constants.LANGUAGE;
  entityAttributes: any = {};
  customEntityAttributes: any;
  attributeFormGroup: UntypedFormGroup;
  hasTemplate: boolean;
  userFieldName: string;
  test:any;
  todayDate:any;

  @ViewChild('entityAttributeTemplate', { static: false }) entityTemplate: EntityAttributeTemplateComponent;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    //private translate: TranslateService,
    private commonService: CommonService
  ) {
    // translate.setDefaultLang(this.language);
    // translate.use(this.language);
  }

  ngOnInit() {
    this.hasTemplate = false;
    let self = this;
    this.userFieldName = undefined;

    self.attributeFormGroup = self._formBuilder.group({

    });
    if (self.pageId) {
      self.commonService.getEntityAttributes(this.pageId).toPromise().then((response) => {
        if (!response || response == null) {
          return;
        }
        if (response && response.loadTemplate) {
          self.hasTemplate = true;
          return;
        }
        if (response) {
          self.entityAttributes = {
            entityAttributeSections: response.userFieldSections
          };
          self.customEntityAttributes = {
            entityAttributeSections: response.userField10Sections
          };
        }
        if (self.entityAttributes && self.entityAttributes.entityAttributeSections) {
          for (let attributeSection of self.entityAttributes.entityAttributeSections) {
            if (attributeSection.attributes) {
              for (let attribute of attributeSection.attributes) {
                if (attribute.userFieldName === 'userField10') {

                } else {
                  let validations = [];
                  if (attribute.attributeConstraint) {
                    if (attribute.attributeConstraint.mandatory && attribute.htmlType !== 'BOOLEAN') {
                      validations.push(Validators.required);
                    }
                    if (attribute.htmlType === 'TEXT' && attribute.attributeConstraint.regex) {
                      validations.push(Validators.pattern(attribute.attributeConstraint.regex));
                    }
                  }
                  let defaultVal = attribute.defaultValue ? attribute.defaultValue : '';
                  if (self.savedObject && self.savedObject[attribute.userFieldName] != null) {
                    if (attribute.htmlType === 'DATE') {
                      defaultVal = new Date(self.savedObject[attribute.userFieldName]);
                    } else {
                      defaultVal = self.savedObject[attribute.userFieldName];
                    }
                  }
                  self.attributeFormGroup.addControl('attribute' + attribute.userFieldName, new UntypedFormControl(defaultVal, validations));
                }
              }
            }
          }
        }
        if (self.customEntityAttributes && self.customEntityAttributes.entityAttributeSections) {
          this.userFieldName = 'userField10';
          if(self.savedObject && self.savedObject[self.userFieldName]){
            self.savedObject[self.userFieldName] = JSON.parse(self.savedObject[self.userFieldName]);
          }
          for (let customAttributeSection of self.customEntityAttributes.entityAttributeSections) {
            if (customAttributeSection.attributes) {
              for (let customAttribute of customAttributeSection.attributes) {
                let validations = [];
                if (customAttribute.attributeConstraint) {
                  if (customAttribute.attributeConstraint.mandatory && customAttribute.htmlType !== 'BOOLEAN') {
                    validations.push(Validators.required);
                  }
                  if (customAttribute.htmlType === 'TEXT' && customAttribute.attributeConstraint.regex) {
                    validations.push(Validators.pattern(customAttribute.attributeConstraint.regex));
                  }
                }
                let defaultVal = customAttribute.defaultValue ? customAttribute.defaultValue : '';
                if (self.savedObject && self.savedObject[self.userFieldName] && self.savedObject[self.userFieldName][customAttribute.key]) {
                  if (customAttribute.htmlType === 'DATE') {
                    defaultVal = new Date(self.savedObject[self.userFieldName][customAttribute.key]);
                  } else {
                    defaultVal = self.savedObject[self.userFieldName][customAttribute.key];
                  }
                }
                self.attributeFormGroup.addControl('attribute' + self.userFieldName + customAttribute.key, new UntypedFormControl(defaultVal, validations));
              }
            }
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  processObject(data) {
    data = data || {};
    if (this.entityAttributes && this.entityAttributes.entityAttributeSections) {
      for (let attributeSection of this.entityAttributes.entityAttributeSections) {
        if (attributeSection.attributes) {
          for (let attribute of attributeSection.attributes) {
            if (attribute.userFieldName === 'userField10') {

            } else {
              if (attribute.htmlType === 'DATE' && this.attributeFormGroup.value['attribute' + attribute.userFieldName]) {
                data[attribute.userFieldName] = this.attributeFormGroup.value['attribute' + attribute.userFieldName].toISOString();
              } else {
                data[attribute.userFieldName] = this.attributeFormGroup.value['attribute' + attribute.userFieldName];
              }
            }
          }
        }
      }
      if (this.customEntityAttributes && this.customEntityAttributes.entityAttributeSections) {
        var customData = {};
        for (let customAttributeSection of this.customEntityAttributes.entityAttributeSections) {
          if (customAttributeSection.attributes) {
            for (let customAttribute of customAttributeSection.attributes) {
              if (customAttribute.htmlType === 'DATE' && this.attributeFormGroup.value['attribute' + this.userFieldName + customAttribute.key]) {
                customData[customAttribute.key] = this.attributeFormGroup.value['attribute' + this.userFieldName + customAttribute.key].toISOString();
              } else {
                customData[customAttribute.key] = this.attributeFormGroup.value['attribute' + this.userFieldName + customAttribute.key];
              }
            }
          }
        }
        data[this.userFieldName + 'Map'] = customData;
        delete data[this.userFieldName];
      }
    }
    if (this.hasTemplate && this.entityTemplate) {
      data = this.entityTemplate.processObject(data);
    }
    return data;
  }

  validateForm() {
    if (this.entityAttributes) {
      this.commonService.validateAllFormFields(this.attributeFormGroup);
    }
    if (this.hasTemplate && this.entityTemplate) {
      this.entityTemplate.validateForm();
    }
  }

  isValid() {
    let flag = true;
    if (this.entityAttributes) {
      flag = this.attributeFormGroup.valid;
    } else if (this.hasTemplate && this.entityTemplate) {
      flag = this.entityTemplate.isValid();
    }
    return flag;
  }
}


